DialogController = App.loadClass "core::Angular/DialogController"
TraitPackage = App.loadClass "portal::Angular/Ratings/Models/TraitPackage"

class exports.TraitPackageDialogController extends DialogController

    constructor: (@scope, @transitions, @repo, @modalInstance, lineups_id, trait_package, trait_suppliers) ->
        super(@scope, @transitions, @modalInstance)

        # empty model for editing within the scope of this dialog
        tp = new TraitPackage()

        if trait_package?
            @scope.trait_package = $.extend tp, trait_package # copy existing model
            @scope.title = 'Edit Trait Package'
        else
            @scope.trait_package = tp # use the empty model
            @scope.title = 'Add Trait Package'

            # automatically set the suffix, but only for new trait packages
            # (we don't want to overwrite the suffix for existing ones)
            @scope.$watch 'trait_package.name', (val) =>
                comp_val = val?.trim().toLowerCase()
                switch comp_val
                    # build in special cases
                    when 'conv', 'conventional'
                        @scope.trait_package.suffix = ''
                    else
                        # normally the suffix should just be set to the name
                        @scope.trait_package.suffix = val


        @scope.trait_suppliers = trait_suppliers

        @scope.show_overflow = true # for the dropdown
        @scope.absolute_errors = false

        @lineups_id = lineups_id

    save: =>
        promise = @repo.saveTraitPackage(@lineups_id, @scope.trait_package).then (response) =>
            if response.status?.type
                @closeWithAlert response.status, response.data

        .catch (response) =>
            @closeWithAlert(type: 'error', msg: 'Failed to save trait package')

        return promise
